import moment from 'moment'
import {type SupportedCodes} from 'src/config/language_helpers.ts'
import 'moment/dist/locale/de.js'

// fallback locale
const locale = import.meta.env.VITE_I18N_FALLBACK_LOCALE || 'de'
moment.locale(locale)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const loadedMomentLocalesMessages: any = {} // can't type it better because moment locale files are not typed

// Due to how moment.js is structured/built, we unfortunately can't dynamically import with
// import.meta.glob('/node_modules/moment/dist/locale/*.js')
const loadMomentLocaleMessages = async (targetLang: SupportedCodes) => {
  // if the locale was already imported before, don't load it again
  if (loadedMomentLocalesMessages[targetLang]) {
    return loadedMomentLocalesMessages[targetLang]
  }

  switch (targetLang) {
  case 'de':
    loadedMomentLocalesMessages[targetLang] = await import('moment/dist/locale/de.js')
    return loadedMomentLocalesMessages[targetLang]
  case 'en':
    loadedMomentLocalesMessages[targetLang] = await import('moment/dist/locale/en-gb.js')
    return loadedMomentLocalesMessages[targetLang]
  case 'es':
    loadedMomentLocalesMessages[targetLang] = await import('moment/dist/locale/es.js')
    return loadedMomentLocalesMessages[targetLang]
  case 'tr':
    loadedMomentLocalesMessages[targetLang] = await import('moment/dist/locale/tr.js')
    return loadedMomentLocalesMessages[targetLang]
  case 'uk':
    loadedMomentLocalesMessages[targetLang] = await import('moment/dist/locale/uk.js')
    return loadedMomentLocalesMessages[targetLang]
  case 'fr':
    loadedMomentLocalesMessages[targetLang] = await import('moment/dist/locale/fr.js')
    return loadedMomentLocalesMessages[targetLang]
  case 'it':
    loadedMomentLocalesMessages[targetLang] = await import('moment/dist/locale/it.js')
    return loadedMomentLocalesMessages[targetLang]
  default:
    throw new Error(`Unsupported locale: ${targetLang}`)
  }
}

export const switchMomentLocale = async (targetLang: SupportedCodes) => {
  // locale already set
  if (moment.locale() === targetLang) return

  await loadMomentLocaleMessages(targetLang)
  moment.locale(targetLang)
}

export default moment
